import { useDeviceType } from '@cian/ui-kit/responsive';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { closeSearchResultsSidebar } from '../../../../common/actions/searchResults';
import { useApplicationContext } from '../../../../common/containers/ApplicationContext';
import { IApplicationState, TThunkDispatch } from '../../../../common/types/redux';
import { fetchMapData } from '../../../actions';
import { selectMapBounds } from '../../../selectors';
import { TMapBounds } from '../../../types/mapBounds';

export const MapFeaturesFetcher: React.FC = () => {
  const { config } = useApplicationContext();
  const deviceType = useDeviceType();
  const isFirstLoadRef = React.useRef(true);
  const dispatch = useDispatch<TThunkDispatch>();
  const mapBounds = useSelector<IApplicationState, TMapBounds>(selectMapBounds);
  const fetchDelayAlgorithm = React.useRef<'throttle' | 'debounce'>('throttle');
  const fetchDelayTime = React.useRef<number>(1000);

  React.useEffect(() => {
    fetchDelayAlgorithm.current = config.get('mapSearchFrontend.fetchDelayAlgorithm') || 'throttle';
    fetchDelayTime.current = config.get('mapSearchFrontend.fetchDelayTime') || 1000;
  }, [config]);

  React.useEffect(() => {
    if (!mapBounds.bounds || !mapBounds.zoom) {
      return;
    }

    dispatch(fetchMapData({ deviceType, shouldCloseListing: true }));

    // При первой загрузке карты mapBounds чуть меняются без реального изменения положения карты
    // и вызывают все связанные с этим обработчики.
    // Проверка же добавлена, чтобы при первом рендере
    // предзагруженные на ноде данные листинга (listingOffers) не стирались.
    if (isFirstLoadRef.current) {
      isFirstLoadRef.current = false;

      return;
    }

    dispatch(closeSearchResultsSidebar());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapBounds.bounds?.[0][0], mapBounds.bounds?.[0][1], mapBounds.bounds?.[1][0], mapBounds.bounds?.[1][1]]);

  return null;
};
